import { useCallback, useEffect, useRef } from 'react';

// Distancia al final, en píxeles, por debajo de la cual se considera que el
// usuario está leyendo lo último.
const UMBRAL_FINAL = 80;

// ¿Sigue el usuario abajo del todo en la conversación abierta?
//
// Hace falta porque las imágenes cargan después de que el panel baje al final:
// al llegar crecen y dejan la vista corta. Quien las pinta pregunta aquí si
// debe volver a bajar, y solo baja si el usuario no se ha ido a leer arriba.
//
// Solo se despega cuando el usuario sube a mano lejos del final. Bajar (también
// la animación de scrollToBottom) o que el contenido crezca no lo despegan.
// Cambiar de chat lo vuelve a pegar, porque cada chat se abre por el final.
function usePegadoAbajo(contenedorRef, claveChat) {
  const pegadoRef = useRef(true);
  const ultimoScrollTopRef = useRef(0);

  useEffect(() => {
    pegadoRef.current = true;
    const contenedor = contenedorRef.current;
    if (!contenedor) return undefined;
    ultimoScrollTopRef.current = contenedor.scrollTop;

    const alDesplazar = () => {
      const { scrollTop, scrollHeight, clientHeight } = contenedor;
      if (scrollHeight - scrollTop - clientHeight < UMBRAL_FINAL) {
        pegadoRef.current = true;
      } else if (scrollTop < ultimoScrollTopRef.current) {
        pegadoRef.current = false;
      }
      ultimoScrollTopRef.current = scrollTop;
    };
    contenedor.addEventListener('scroll', alDesplazar, { passive: true });
    return () => contenedor.removeEventListener('scroll', alDesplazar);
  }, [contenedorRef, claveChat]);

  const pegadoAbajo = useCallback(() => pegadoRef.current, []);
  const marcarPegado = useCallback(() => {
    pegadoRef.current = true;
  }, []);

  return { pegadoAbajo, marcarPegado };
}

export default usePegadoAbajo;
